import type { SVGProps } from 'react';
const SvgUserGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.167 16.667h4.166V15a2.5 2.5 0 0 0-4.463-1.548m.297 3.215H5.833m8.334 0V15c0-.547-.106-1.07-.297-1.548m-8.037 3.215H1.667V15a2.5 2.5 0 0 1 4.463-1.548m-.297 3.215V15c0-.547.106-1.07.297-1.548m0 0a4.168 4.168 0 0 1 7.74 0M12.5 5.833a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m5 2.5a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0m-11.667 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0"
    />
  </svg>
);
export default SvgUserGroup;
